import { createTheme } from '@mui/material/styles';
import { BRAND, FONT_FAMILY } from './brand';

// Theme según el Manual de Marca VideoCallShop (colores en src/brand.js).
const theme = createTheme({
    palette: {
        primary: {
            main: BRAND.blue,
            light: BRAND.blueLight,
            dark: BRAND.blueDark,
            contrastText: '#ffffff',
        },
        secondary: {
            main: BRAND.green,
            light: BRAND.greenLight,
            dark: BRAND.greenDark,
            contrastText: BRAND.night,
        },
        success: {
            main: BRAND.greenDark,
            contrastText: BRAND.night,
        },
        error: {
            main: BRAND.error,
        },
        text: {
            primary: BRAND.night,
            secondary: BRAND.textSoft,
        },
        background: {
            default: BRAND.cloud,
            paper: '#ffffff',
        },
        divider: '#DDE7F1',
    },
    shape: {
        borderRadius: 12,
    },
    typography: {
        fontFamily: FONT_FAMILY,
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: {
            fontWeight: 700,
            marginBottom: '1rem',
        },
        h5: {
            fontWeight: 600,
            marginBottom: '0.75rem',
        },
        h6: { fontWeight: 600 },
        button: { fontWeight: 600 },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    textTransform: 'none',
                    fontWeight: 600,
                },
                contained: {
                    boxShadow: '0 6px 16px -8px rgba(15,27,45,0.45)',
                    '&:hover': {
                        boxShadow: '0 10px 22px -10px rgba(15,27,45,0.55)',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    boxShadow: '0 4px 18px -10px rgba(15,27,45,0.35)',
                    '&:hover': {
                        boxShadow: '0 10px 28px -12px rgba(15,27,45,0.45)',
                    },
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                // el azul principal sobre blanco no llega al contraste AA en texto chico
                root: { color: BRAND.blueDark },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    paddingTop: '2rem',
                    paddingBottom: '2rem',
                },
            },
        },
    },
});

export default theme;
